import { render, staticRenderFns } from "./FontAdjuster.vue?vue&type=template&id=f36dc984&scoped=true"
import script from "./FontAdjuster.vue?vue&type=script&lang=js"
export * from "./FontAdjuster.vue?vue&type=script&lang=js"
import style0 from "./FontAdjuster.vue?vue&type=style&index=0&id=f36dc984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36dc984",
  null
  
)

export default component.exports